import React, { useState } from 'react';
import classNames from 'classnames';

const Rating = (props) => {
  const [isPosted, setIsPosted] = useState(false);
  const [value, setValue] = useState(null);

  const handleClick = (value) => {
    setIsPosted(true);
    setValue(value);
  };

  const { FeedbackRatingModel } = props;

  if (!FeedbackRatingModel) return null;

  return (
    <div
      className={classNames({
        rating: true,
        'rating--is-posted': isPosted,
      })}
    >
      {FeedbackRatingModel.Title && (
        <h2 className="rating__heading">{FeedbackRatingModel.Title}</h2>
      )}
      <div className="rating__form">
        <button
          type="button"
          className={classNames({
            rating__lbl: true,
            'rating__lbl--icon4': true,
            'rating__lbl--selected': value === 4,
          })}
          value="4"
          onClick={() => handleClick(4)}
          disabled={isPosted}
        >
          <span className="show-for-sr">{FeedbackRatingModel.Satisfied}</span>
        </button>
        <button
          type="button"
          className={classNames({
            rating__lbl: true,
            'rating__lbl--icon3': true,
            'rating__lbl--selected': value === 3,
          })}
          value="3"
          onClick={() => handleClick(3)}
          disabled={isPosted}
        >
          <span className="show-for-sr">
            {FeedbackRatingModel.SlightlySatisfied}
          </span>
        </button>
        <button
          type="button"
          className={classNames({
            rating__lbl: true,
            'rating__lbl--icon2': true,
            'rating__lbl--selected': value === 2,
          })}
          value="2"
          onClick={() => handleClick(2)}
          disabled={isPosted}
        >
          <span className="show-for-sr">
            {FeedbackRatingModel.SlightlyUnsatisfied}
          </span>
        </button>
        <button
          type="button"
          className={classNames({
            rating__lbl: true,
            'rating__lbl--icon1': true,
            'rating__lbl--selected': value === 1,
          })}
          value="1"
          onClick={() => handleClick(1)}
          disabled={isPosted}
        >
          <span className="show-for-sr">{FeedbackRatingModel.Unsatisied}</span>
        </button>
      </div>
    </div>
  );
};

export default Rating;
